function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Nearest-flight",
  transform: "translate(-743 -938)",
  fill: "#95A0B3"
}, /*#__PURE__*/React.createElement("g", {
  id: "extra",
  transform: "translate(311 924)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(265 2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon-Common-/-16-/-BriefcaseNo",
  transform: "translate(166 10)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.385 2l.707.707L14.798 6H15v10H5v-.202l-3.293 3.294L1 18.385l2.39-2.391h-.005L4 15.379v.005l1-1v-.005L13.379 6h.005l4-4zm-.889 4A1.5 1.5 0 0118 7.496v7.008A1.5 1.5 0 0116.496 16H16V6zM4 6v7.964l-1.577 1.58A1.487 1.487 0 012 14.503V7.496A1.5 1.5 0 013.504 6H4zm8.01-3c.546 0 .99.333.99.757v1.208l-1 1V4H8v2h3.965L5 12.964V6h2V3.757C7 3.339 7.451 3 7.99 3h4.02z",
  id: "NoBriefcase"
}))))))));